<!--  -->
<template>
  <div>
    <div class="h54"></div>
    <div class="clear"></div>
    <div class="footerBox">
        <div class="footer">
        <ul>
            <li>
                <router-link to="/">
                    <img :src="`/static/images_m/${'/'==$route.path?'shouye_a':'shouye'}.svg`">
                    <p>首页</p>
                </router-link>
            </li>
            <li  >
                <router-link to="/mycourses">
                <img :src="`/static/images_m/${'/mycourses'==$route.path?'kecheng_a':'kecheng'}.svg`">
                <p>课程</p>
           </router-link>
            </li>
            <li>
             <router-link to="/papercenter">
               <img :src="`/static/images_m/${'/papercenter'==$route.path?'kaoshi_a':'kaoshi'}.svg`">
                <p>考试</p>
            </router-link>
            </li>
            <li>
            <router-link to="/liveview">
                <img :src="`/static/images_m/${'/liveview'==$route.path?'zhibo_a':'zhibo'}.svg`">
                <p>直播</p>
           </router-link>
            </li>
            <li>
            <router-link to="/personcenter">
                <img :src="`/static/images_m/${'/personcenter'==$route.path?'wode_a':'wode'}.svg`">
                <p>我的</p>
            </router-link>
            </li>
        </ul>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    user() {
      return this.$store.getters.user;
    },
    EnterPerson(){
        if(this.$route.path=="/personcenter"){
             localStorage.removeItem("eleTokenWrd001");
            this.$store.dispatch("clearCurrentState");
            // 页面跳转
            this.$router.push("/login");
        }
        else{
            this.$router.push("/personcenter");
        }
    }
  },
};
</script>
<style  lang="scss" scoped>
  @import "@/assets/css/style_Phone.scss";
</style>
